"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var c = (0, BemBuilder_1.default)("token-management");
var TokenManagementOauth = (function (_super) {
    __extends(TokenManagementOauth, _super);
    function TokenManagementOauth() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TokenManagementOauth.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement(kaleidoscope_1.Card, null,
            react_1.default.createElement(kaleidoscope_1.RainbowBar, null),
            react_1.default.createElement("div", { className: "space-inset-m" },
                react_1.default.createElement(kaleidoscope_1.Heading, { className: "space-stack-s", level: "5" }, "Access your custom fields as Qwilr tokens"),
                react_1.default.createElement("div", { className: "space-stack-s" },
                    react_1.default.createElement(kaleidoscope_1.Text, null,
                        "Want more powerful personalisation with ",
                        this.props.integrationName,
                        "? Grant access to use your custom CRM fields as tokens in your Qwilr templates.")),
                react_1.default.createElement("div", { className: c("oauth-prompt-footer") },
                    react_1.default.createElement(kaleidoscope_1.Button, { className: c("oauth-prompt-button"), type: kaleidoscope_1.ButtonType.Secondary, onClick: function () { return _this.props.authorizeUser(); } }, "Grant access")))));
    };
    return TokenManagementOauth;
}(react_1.default.Component));
exports.default = TokenManagementOauth;
